import i18next from 'i18next';
import common from '../../common';
import Text from '../../ui/Text';

export default class ScenarioCard extends PIXI.Container {
	constructor(data, index) {
		super();

		this._index = index;
		this._data = data;
		this._background = null;
		this._playButton = null;
		this._disasterTitle = null;
		this._scenarioImage = null;
		this._scenarioIcon = null;
		this._scenarioLocation = null;
		this._scenarioDescription = null;

		this.signals = {
			play: new P3.utils.MiniSignal(),
		};

		this.init();
	}

	init() {
		this._background = new PIXI.NineSlicePlane(P3.assets.texture('panel_scenario_9slice'), 70, 100, 70, 80);

		this._background.width = 480;
		this._background.height = 0;
		this.addChild(this._background);

		this._disasterTitle = new Text(this._data.disastername, { font: '40px', fontWeight: '900', align: 'center', tint: 0xffffff });

		this._disasterTitle.anchor.set(0, 0);
		this.addChild(this._disasterTitle);

		this._scenarioImage = new PIXI.Sprite(P3.assets.texture(this._data.image));

		this._scenarioImage.anchor.set(0.5, 0);
		this._scenarioImage.width += 3;
		this._scenarioImage.scale.y = this._scenarioImage.scale.x;
		this.addChild(this._scenarioImage);

		this._scenarioIcon = new PIXI.Sprite(P3.assets.texture(this._data.icon));

		this._scenarioIcon.anchor.set(0.5);
		this.addChild(this._scenarioIcon);

		this._scenarioLocation = new Text(this._data.name, { font: '36px', fontWeight: 'bold', align: 'left', tint: 0x0, maxWidth: 400 });

		this._scenarioLocation.anchor.set(0);
		this.addChild(this._scenarioLocation);

		this._scenarioDescription = new Text(this._data.description, { font: '36px', align: 'left', tint: 0x0, maxWidth: 400 });

		this._scenarioDescription.anchor.set(0);
		this.addChild(this._scenarioDescription);

		const playLabel = new Text('gui.selectscenario.play', { font: '32px', align: 'center', tint: 0xFFFFFF });

		this._playButton = common.buttonFactory.createButton({
			normal: { textureName: 'btn_blue_fill_large_9slice_out', width: playLabel.width + 105, height: 75, left: 35, top: 35, right: 35, bottom: 35 },
			over: { textureName: 'btn_blue_fill_large_9slice_over', width: playLabel.width + 105, height: 75, left: 35, top: 35, right: 35, bottom: 35 },
		});
		this._playButton.signals.click.add(this.onPlayButtonClick, this);
		this.addChild(this._playButton);

		playLabel.anchor.set(0, 0.5);
		playLabel.position.set(this._playButton.width * -0.5 + 35, 0);
		this._playButton.animation.addChild(playLabel);

		this._playButton.accessibleTitle = i18next.t('accessibility.button.playDifficulty', { DIFFICULTY: i18next.t(`gui.general.disasters.${common.config.scenarios[this._index]}`) });
		this._playButton.tabIndex = 1;

		const playIcon = new PIXI.Sprite(P3.assets.texture('icon_play'));

		playIcon.anchor.set(0.5);
		playIcon.position.set(this._playButton.width * 0.5 - 35, 0);
		this._playButton.animation.addChild(playIcon);

		this.resize(this._scenarioImage.height + this._scenarioLocation.height + this._scenarioDescription.height + 250);
	}

	resize(height) {
		this._background.height = height;

		this._background.position.set(this._background.width * -0.5, this._background.height * -0.5);
		this._disasterTitle.position.set(this._background.width * -0.5 + 40, this._background.height * -0.5 + 37);
		this._scenarioImage.position.set(0, this._background.height * -0.5 + 87);
		this._scenarioIcon.position.set(this._scenarioImage.x, this._scenarioImage.y + this._scenarioImage.height * 0.5);
		this._scenarioLocation.position.set(this._background.width * -0.5 + 50, this._scenarioImage.y + this._scenarioImage.height + 10);
		this._scenarioDescription.position.set(this._background.width * -0.5 + 50, this._scenarioLocation.y + this._scenarioLocation.height + 10);
		this._playButton.position.set(0, this._background.height * 0.5 - 90);
	}

	onPlayButtonClick() {
		this.signals.play.dispatch(this._index);
	}

	destroy() {
		super.destroy();
	}
}
